import { round } from "es-toolkit/compat";
//#region ../erd-editor-schema/dist/v3/parser/migrateScroll.js
var boxTerm = (length, zoomLevel) => length * (1 - zoomLevel) / 2;
function migrateScrollToOrigin(box) {
	return {
		originX: round(box.scrollLeft + boxTerm(box.width, box.zoomLevel), 4),
		originY: round(box.scrollTop + boxTerm(box.height, box.zoomLevel), 4)
	};
}
//#endregion
export { migrateScrollToOrigin };
